import type { components } from '@pba/types-openapi-client';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type GetMembersParams = {
  cursor?: string;
  limit?: number;
};

export const getMembers = async (id: string, params: GetMembersParams) =>
  apiClient.get<Array<components['schemas']['UserList']>, ApiClientResponse<Array<components['schemas']['UserList']>>>(
    routes.community.members(id),
    {
      params,
    },
  );
